module.exports = __webpack_public_path__ + "img/pluseDes.3a03a76f.png";